<template>
  <v-container>
    <p
      class="listTotalHeader"
      v-if="this.totalTransactionsInDB && this.totalTransactionsInDB > 0"
    >
      {{ `${this.totalTransactionsInDB} Transactions found (showing the last 2000 Records)` }}
    </p>
    <Loader v-if="isLoading" />
    <Empty v-else-if="transactions && (transactions.length == 0 || totalTransactions == 0)"/>
    <b-table
      v-else-if="!isLoading"
      :data="transactions"
      class="table"
	  v-bind:mobileCards="false"
    >
      <template slot-scope="props">
        <b-table-column field="hash" label="TxHash">
          <span v-if="props.row.hash && props.row.hash.length < 40">
            <i v-if="props.row.txStatus === 'Failure'" style="font-style:normal; color:red; margin-right:2px;">&#9432;</i>{{ props.row.hash }}
          </span>
          <router-link
            v-else
            class="router-link short-addr"
            :to="{ name: 'tx', params: {txhash: props.row.hash}}"
          >
            <i v-if="props.row.txStatus === 'Failure'" style="font-style:normal; color:red; margin-right:2px;">&#9432;</i>{{ props.row.hash }}
          </router-link>
        </b-table-column>
        <b-table-column field="blockNumber" label="Block">
          <router-link
            class="router-link"
            :to="{ name: 'block', params: {blockNumber: props.row.blockNumber}}"
          >
            {{ props.row.blockNumber }}
          </router-link>
        </b-table-column>
        <b-table-column field="timeStamp" label="Age">
          <v-tooltip bottom>
              <span slot="activator">
                  <timeago
                    :datetime="props.row.timestamp"
                    :auto-update="10">
                  </timeago>
              </span>
              <span>{{ new Date(props.row.timestamp).toISOString() }}</span>
            </v-tooltip>
        </b-table-column>
        <b-table-column field="from" label="From">
          <span v-if="props.row.from && props.row.from.length < 40">
            {{ props.row.from }}
          </span>
          <router-link
            v-else
            class="router-link short-addr"
            :to="{ name: 'address', params: {address: props.row.from}}"
          >
            {{ props.row.from }}
          </router-link>
        </b-table-column>
        <b-table-column label="">
          <img
            class="transferIcons"
            v-if="props.row.to"
            src="@/assets/img/icons/transfer_out_to_right.png"
            alt="transfer out"
          />
        </b-table-column>
        <b-table-column field="to" label="To">
          <router-link
            v-if="props.row.to"
            class="router-link short-addr"
            v-bind:class="{'contract-addr':props.row.isContract}"
            :to="{ name: 'address', params: {address: props.row.to}}"
          >
            {{ props.row.to }}
          </router-link>
          <span v-else-if="props.row.txType">
            {{ props.row.txType }}
          </span>

        </b-table-column>
        <b-table-column field="value" label="Value">
          {{ `${(props.row.value).toLocaleString()} CMT` }}
        </b-table-column>
        <b-table-column field="value" label="TxFee">
            {{ props.row.txResult ? props.row.txResult.fee.value : "" }}
        </b-table-column>
      </template>

      <!-- <template slot="detail" slot-scope="props">
          <article class="media">
              <div class="media-content">
                  <div class="content">
                      <p>
                      <small>
                          Block:
                          <router-link class="router-link" :to="{ name: 'block', params: {blockNumber: props.row.blockNumber}}">
                            {{ props.row.blockNumber }}
                          </router-link>
                        </small>
                        <br>
                        <small>Gas Limit: {{ props.row.gas }}</small>
                        <br>
                        <small>Gas Price: {{ props.row.gasPrice }}</small>
                        <br>
                        <small>Nonce: {{ props.row.nonce }}</small>
                        <br>
                        <small>Transaction Index: {{ props.row.transactionIndex }}</small>
                        <br>
                      </p>
                  </div>
              </div>
          </article>
      </template> -->
    </b-table>
    <el-pagination
      small
      background
      @current-change="shift"
      @prev-click="shift(currentPage-1)"
      @next-click="shift(currentPage+1)"
      :current-page="currentPage"
      layout="prev, pager, next"
      :pager-count=5
      :page-size="pageSize"
      :total="totalTransactions">
    </el-pagination>
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import Loader from '../reusables/loader.vue';
import Empty from '../reusables/empty.vue';
import toast from '../../tools/toast';

export default {
  name: 'Transactions',
  data() {
    return {
      currentPage: 1,
      pageSize: 20,
      isLoading: false,
    };
  },
  components: {
    Loader,
    Empty,
  },
  watch: {
    transactions() {
      this.isLoading = false;
    },
    '$route.query.page': function (newPage) {
      this.initData(newPage);
    },
  },
  methods: {
    initData(page) {
      if (!isNaN(page)) {
        const pageQuery = parseInt(page);
        this.currentPage = pageQuery;
        this.isLoading = true;
        this.$store.dispatch('fetchTransactions', {
          limit: this.pageSize,
          page: pageQuery,
        });
      }
    },
    shift(page) {
      this.$router.push({ path: this.$route.path, query: { page } });
    },
    onCopy(e) {
      toast.copied(`${e.text.substring(0, 10)}...`);
    },
    onError() {
      this.$notify.error({
        title: 'Error',
        message: 'Failed to copy address',
        duartion: 10,
      });
    },
    appendQueries() {
      const pageQuery = parseInt(this.$route.query.page);
      this.currentPage = pageQuery;
      this.$router.push({
        path: this.$route.path,
        query: { page: pageQuery || 1 },
      });
      this.initData(pageQuery);
    },
  },

  computed: {
    ...mapGetters([
      'transactions',
      'totalTransactions',
      'totalTransactionsInDB',
      'fetchError',
    ]),
  },
  created() {
    this.appendQueries();
  },
};
</script>

